module.exports = __webpack_public_path__ + "static/img/icon_bjt.1784115679763.png";